import { render, staticRenderFns } from "./Confidentialite.vue?vue&type=template&id=245fde1c&"
import script from "./Confidentialite.vue?vue&type=script&lang=js&"
export * from "./Confidentialite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports